import { useTheme } from '@mui/material/styles';
import { LanguageOutlined } from '@mui/icons-material';

import { Status, TOGGLE_STATUS } from '../../../../../common/status/interfaces';
import StatusElement from '../../../../../common/status/statusElement';
import { nortadaLogger } from '../../../../../common/logger';

interface Props {
  status: Status;
}

export const AppsStatusMapper = ({ status }: Props) => {
  const theme = useTheme();

  switch (status.toUpperCase()) {
    case TOGGLE_STATUS.ENABLED: {
      return <StatusElement Icon={LanguageOutlined} text="Online" color={theme.palette.success.main} />;
    }
    case TOGGLE_STATUS.DISABLED: {
      return <StatusElement Icon={LanguageOutlined} text="Offline" color={theme.customTypography.disabled.color} />;
    }
    default: {
      throw nortadaLogger.critical(`${status} status is not supported`);
    }
  }
};
